export function centerAndRescaleEvent(creationController, containerSize) {
  resizeStageContainer(creationController.stage, containerSize);
  creationController.scale = resizeStageForContainer(
    creationController.stage,
    containerSize,
    creationController.projectSize,
    creationController.zoomCorrect
  );
}

function resizeStageContainer() {
  // stage, containerSize
  // stage.width(containerSize.width - 20);
  // stage.height(containerSize.height - 20);
}

export function resizeStageForContainer(stage, containerSize, project = null, zoomCorrect = false) {
  const containerWidth = containerSize.width;
  const containerHeight = containerSize.height;
  let contentWidth;
  let contentHeight;

  let correctZoom = 0.02;

  if (project == null || zoomCorrect) {
    correctZoom = 0;
  }

  if (project != null) {
    contentWidth = project.width;
    contentHeight = project.height;
  } else {
    contentWidth = stage.width();
    contentHeight = stage.height();
  }

  let scale;
  if (contentWidth / containerWidth > contentHeight / containerHeight) {
    scale = containerWidth / contentWidth - correctZoom;
  } else {
    scale = containerHeight / contentHeight - correctZoom;
  }

  if (scale < 0.25 || scale > 6) {
    scale = setScaleLimit(scale);
  }

  stage.x(0);
  stage.y(0);
  stage.scale({ x: scale, y: scale });
  return scale;
}

function setScaleLimit(newScale) {
  if (newScale < 0.25) {
    return 0.25;
  }

  if (newScale > 6) {
    return 6;
  }
}
